import * as Yup from "yup";

export const SmsLoginValidation = (t, countryCode) => {
  return Yup.object({
    phone_number: Yup.string()
      .required(t("auth.phoneNumber.validMessage"))
      .matches(
        countryCode === "TR" ? /^\(\d{3}\)\s\d{3}\s\d{4}$/ : /^\d{13}$/,
        t("auth.phoneNumber.validMessage")
      ),
  });
};
